// extracted by mini-css-extract-plugin
module.exports = {"address":"JA-bpc","shine-lines":"_2Wsp7I"};